import axios from 'axios';
import type { CompanyInformation } from '../types/CompanyInformation';
import { error } from 'console';

export const getCompanyInformation = () => {
  return axios
    .get(`/api/get/users/company`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getStorageUsage = () => {
  return axios
    .get(`/api/v1/storage/status`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateCompanyInformation = (data: CompanyInformation) => {
  const bankInfoArray = data.bankInfo.map(bank => ({
    bankIndex: bank.bankIndex,
    bankName: bank.bankName,
    branchName: bank.branchName,
    selectedAccountType: bank.selectedAccountType,
    accountNumber: bank.accountNumber,
    accountName: bank.accountName
  }));
  return axios
    .put(
      `/api/get/users/company`,
      {
        name: data.name,
        postal_code: data.postalCode,
        address: data.address,
        phone_number: data.phoneNumber,
        fax_number: data.faxNumber,
        mfa_enabled: data.mfaEnabled,
        construction_license: data.constructionLicense,
        email: data.email,
        company_code: data.companyCode,
        invoice_free_field: data.invoiceFreeField,
        receipt_copy_enabled: data.receiptCopyEnabled,
        bankInfo: bankInfoArray
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const addCompanyStamp = (tenant_id: any, file_obj: any) => {
  //console.log("file_objapi", file_obj)
  return axios
    .post(
      `/api/v1/upload/company/stamp/${tenant_id}`,

      file_obj,

      {
        headers: {
          withCredentials: true,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteCompanyStamp = (tenant_id: any) => {
  return axios
    .delete(
      `/api/v1/delete/company/stamp/${tenant_id}`,

      {
        headers: {
          withCredentials: true,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCompanyStamp = (tenant_id: any) => {
  return axios
    .get(`/api/v1/get/company/stamp/${tenant_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const addCompanyLogo = (tenant_id: any, file_obj: any) => {
  //console.log("file_objapi", file_obj)
  return axios
    .post(
      `/api/v1/upload/company/logo/${tenant_id}`,

      file_obj,

      {
        headers: {
          withCredentials: true,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteCompanyLogo = (tenant_id: any) => {
  return axios
    .delete(
      `/api/v1/delete/company/logo/${tenant_id}`,

      {
        headers: {
          withCredentials: true,
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCompanyLogo = (tenant_id: any) => {
  return axios
    .get(`/api/v1/get/company/logo/${tenant_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getCompanyFreeField = () => {
  return axios
    .get('/api/v1/get/company/invoice_free_field', {
      headers: {
        withCredentials: true
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getBankList = () => {
  return axios
    .get('/api/v1/get/company/banks', {
      headers: {
        withCredentials: true
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
